define('viewmodels/welcome',[],function () {
  var ctor = function () {
    this.title = "Hello";
    this.subHeader = "";
    this.contactList = [
      //   {
      //     title: "Twitter",
      //     url: "http://twitter.com/shameen_",
      //   },
      //   {
      //     title: "YouTube",
      //     url: "http://youtube.com/whatshameen",
      //   },
      {
        title: "GitHub",
        url: "https://github.com/shameen",
      },
    ];
  };

  return ctor;
});

